export default "__VITE_ASSET__Dvt1CahB__"